import flatpickr from 'flatpickr'
import 'flatpickr/dist/flatpickr.css'
import easydropdown from 'easydropdown'
import { on } from 'delegated-events'
import scrollTo from '../common/scrollTo'
import { pristineConfig } from '../components/forms'
import Pristine from 'pristinejs'

const SELECTORS = Selectors({
  bookingForm: 'booking-form',
  slotsField: 'BookingForm_BookingForm_Slots',
  availableSlotsField: 'BookingForm_BookingForm_AvailableSlots',
  selectedSlotsHolder: 'booking-selected-slots',
  dateFieldHolder: 'BookingForm_BookingForm_Date_Holder',
  dateField: 'BookingForm_BookingForm_Date',
  characterCounterField: '[maxlength]'
})

const $form = document.querySelector(SELECTORS.asClass('bookingForm'))
const $slotsField = document.getElementById(SELECTORS.slotsField)
const $availableSlotsField = document.getElementById(SELECTORS.availableSlotsField)
const $selectedSlotsHolder = document.querySelector(SELECTORS.asClass('selectedSlotsHolder'))
const $dateField = document.getElementById(SELECTORS.dateField)
const $characterCounterFields = document.querySelectorAll(SELECTORS.characterCounterField)

const state = {
  bookingSpaceId: null,
  availableSlotsForDate: [],
  dateFieldPicker: null,
  pristine: null
}

const fn = {
  init: () => {
    if ($form && $form.classList.contains('details-step')) {
      state.bookingSpaceId = document.querySelector('input[name=SpaceID]').value

      fn.bindEvents()
      fn.setupValidation()
    }
  },

  bindEvents: () => {
    // Setup date picker
    state.dateFieldPicker = flatpickr($dateField, {
      altInput: true,
      onChange: fn.handleDateChange,
      onReady: function () {
        $.ajax({
          type: 'get',
          dataType: 'json',
          url: `${$form.dataset.controllerUrl}fetchdatedata`,
          data: {
            bookingSpaceId: state.bookingSpaceId
          },
          success: (resp) => {
            if (resp) {
              this.set('minDate', resp[0]),
              this.set('enable', resp)
            }
          }
        })
      }
    })

    // Setup available slot picker
    const opts = {
      behavior: {
        openOnFocus: true,
        maxVisibleItems: 8,
        liveUpdates: true
      },
      callbacks: {
        onSelect: value => fn.addSlot(value)
      }
    }

    const $placeholder = $availableSlotsField.querySelector('option[value=""]')

    if ($placeholder && !$placeholder.hasAttribute('data-placeholder')) {
      $placeholder.setAttribute('data-placeholder', true)
      $placeholder.textContent = 'Select One'
    }

    if (!$placeholder) {
      $($availableSlotsField).prepend('<option value="" data-placeholder>Select One</option>')
    }

    easydropdown($availableSlotsField, opts)

    fn.handleSlotChange()

    on('click', '.booking-selected-slot__remove', e => fn.removeSlot(e.target.dataset.id))

    // Setup character counter fields
    $characterCounterFields.forEach($f => {
      const currentTotal = $f.value.length
      const maxTotal = $f.getAttribute('maxlength')

      const $counterEl = document.createElement('div')
      $counterEl.className = 'character-counter'
      $counterEl.innerHTML = `<span>${currentTotal}</span>/${maxTotal} characters`
      $f.closest('.field__wrapper').appendChild($counterEl)
    })

    on('keyup', SELECTORS.characterCounterField, e => {
      const $field = e.target

      const currentTotal = $field.value.length
      const maxTotal = $field.getAttribute('maxlength')

      const totals = `<span>${currentTotal}</span>/${maxTotal} characters`
      $field.closest('.field__wrapper').querySelector('.character-counter').innerHTML = totals
    })
  },

  setupValidation: () => {
    const pristine = new Pristine($form, pristineConfig)
    state.pristine = pristine

    // Revalidate easydropdown fields on change
    on('change',
      `${SELECTORS.asClass('bookingForm')} select`,
      e => pristine.validate(e.target)
    )

    $form.addEventListener('submit', (e) => {
      if (e.target.skipValidation) {
        return true
      }

      const valid = pristine.validate()

      if (!valid) {
        e.preventDefault()
        const $firstError = $form.querySelector('.field.has-error')

        if ($firstError) {
          scrollTo($firstError, 150, () => $firstError.querySelector('input') && $firstError.querySelector('input').focus())
        }

        return false
      }
    })
  },

  handleDateChange: (_, dateStr) => {
    if (dateStr) {
      $.ajax({
        type: 'get',
        dataType: 'json',
        url: `${$form.dataset.controllerUrl}fetchdateslotdata`,
        data: {
          bookingSpaceId: state.bookingSpaceId,
          date: dateStr
        },
        success: (resp) => {
          state.availableSlotsForDate = resp
          fn.updateAvailableSlots()
        }
      })
    }
  },

  addSlot: (id) => {
    const option = Array.from($slotsField.options).find(o => o.value === id)

    if (option) {
      option.selected = true
      fn.updateAvailableSlots()
      fn.handleSlotChange()

      state.pristine.validate($slotsField)
    }
  },

  removeSlot: (id) => {
    const option = Array.from($slotsField.options).find(o => o.value === id)

    if (option) {
      option.selected = false
      fn.updateAvailableSlots()
    }

    fn.handleSlotChange()
  },

  updateAvailableSlots: () => {
    let isActive = false

    if (state.availableSlotsForDate.length) {
      const selectedSlots = fn.getSelectedSlots()
      let html = '<option value="" data-placeholder>Select One</option>'

      state.availableSlotsForDate.forEach(opt => {
        const disabled = selectedSlots.indexOf(opt.id) !== -1 ? 'disabled' : ''
        html += `<option value="${opt.id}" ${disabled}>${opt.time} (${opt.cost})</option>`
      })

      $availableSlotsField.innerHTML = html
      isActive = true

      const usedSlots = state.availableSlotsForDate.filter(slot => selectedSlots.includes(slot.id))

      if (usedSlots.length === state.availableSlotsForDate.length) {
        state.dateFieldPicker.clear()
        isActive = false
      }
    }

    $availableSlotsField.disabled = !isActive
    $availableSlotsField.closest('.field.dropdown').classList.toggle('is-active', isActive)
  },

  getSelectedSlots: () => {
    return Array.from($slotsField.options)
      .filter(o => o.selected)
      .map(o => parseInt(o.value))
  },

  handleSlotChange: () => {
    const selected = fn.getSelectedSlots()

    if (selected.length) {
      $.ajax({
        type: 'get',
        dataType: 'json',
        url: `${$form.dataset.controllerUrl}fetchslotdata`,
        data: {
          slots: selected.join(',')
        },
        success: resp => fn.buildSelectedSlots(resp)
      })
    } else {
      fn.buildSelectedSlots([])
    }
  },

  buildSelectedSlots: (slots) => {
    let html = ''

    slots.forEach(slot => {
      html += `<div class="booking-selected-slot">
        <div class="booking-selected-slot__inner">
          <button type="button" class="booking-selected-slot__remove" aria-label="Remove Slot" data-id="${slot.id}">&times;</button>
          <div class="booking-selected-slot__cost">${slot.cost}</div>
          <div class="booking-selected-slot__date">${slot.date}</div>
          <div class="booking-selected-slot__time">${slot.time}</div>
        </div>
      </div>`
    })

    $selectedSlotsHolder.innerHTML = html
    $selectedSlotsHolder.classList.toggle('is-active', html !== '')
  }
}

export default {
  can: () => document.body.classList.contains('pagetype-bookingrequestpage'),
  run: fn.init
}
